module.exports = __webpack_public_path__ + "img/work_order.3f555605.png";